// File download utility functions

/**
 * Download a file from a blob
 * @param {Blob} blob - The file blob
 * @param {string} filename - The filename for download
 */
export const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

/**
 * Download Excel file
 * @param {Blob} blob - The Excel file blob
 * @param {string} reportId - The report ID for filename
 */
export const downloadExcelFile = (blob, reportId) => {
  downloadFile(blob, `report_${reportId}.xlsx`);
};

/**
 * Download PDF file
 * @param {Blob} blob - The PDF file blob
 * @param {string} reportId - The report ID for filename
 */
export const downloadPDFFile = (blob, reportId) => {
  downloadFile(blob, `report_${reportId}.pdf`);
};

/**
 * Download file with custom filename
 * @param {Blob} blob - The file blob
 * @param {string} filename - The custom filename
 */
export const downloadFileWithName = (blob, filename) => {
  downloadFile(blob, filename);
};

/**
 * Get file extension from MIME type
 * @param {string} mimeType - The MIME type
 * @returns {string} - The file extension
 */
export const getFileExtension = (mimeType) => {
  const mimeToExt = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-excel": "xls",
    "application/pdf": "pdf",
    "text/csv": "csv",
    "application/json": "json",
  };
  return mimeToExt[mimeType] || "bin";
};

/**
 * Format file size
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
